import * as React from "react"
import {CircularPercentageSeeker} from "@ui-seeker/core";


const filterSelector = (value) => {
    if (value > 79) return "80% - 100%"
    else if (value > 20) return "21% - 79%"
    else if (value >= 0) return "0% - 20%"
    return "Error"
}

export default function visibilityColumn() {
    return [{
        name: 'visibility', label: 'Visibility',
        options: {
            display: 'excluded',
            customBodyRowRender: (value, row) => filterSelector(value)
        }
    },{
        name: 'visibility',
        label: 'Visibility',
        options: {
            filter: false,
            customBodyRowRender: (value, row) => {
                const pattern = [
                    { value: 80, color: "#00b050" },
                    { value: 21, color: "#facc58" },
                    { value: 0, color: "#d44933" },
                    { value: "else", color: "#d44933" }
                ];

                return  <CircularPercentageSeeker value={value} pattern={pattern} />
            }
        }
    }]
}